// Web Component: SelligentCarousel
// Estende CustomCarousel per integrare prodotti e tracking Selligent tramite API e widget.
// Attributi richiesti: data-country
// Dipendenze: CustomCarousel, axios, presenza di dati selligentProducts
// Limiti: richiede struttura HTML compatibile e dati selligent corretti
// Utilizzato per mostrare caroselli prodotti Selligent
class SelligentCarousel extends CustomCarousel {
  static trackUrl = 'https://site-azp.slgnt.eu/frontend/api/track';
  static widgetUrlEu = 'https://offer.slgnt.eu';
  static widgetUrlUs = 'https://offer.slgnt.us';
  static SID = 'selligent_sid';
  static TID = 'selligent_tid';
  widgetUrl;
  static LAZY = false;

  connectedCallback() {
    this.widgetUrl = this.dataset.country.toLowerCase() === 'us' ? SelligentCarousel.widgetUrlUs : SelligentCarousel.widgetUrlEu;
    this.init();
  }

  start = (slgResponse) => {
    this.selligentProducts = slgResponse;
    const skus = this.selligentProducts.map((sku) => {
      return sku.ITEMCODE_ID.split('-')[0];
    });
    this.getProducts(skus);
  }

  init = () => {
    if(SelligentCarousel.LAZY){
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if(entry.isIntersecting) {
            this.checkTrack();
            observer.disconnect();
          }
        });
      });
      observer.observe(this);
    } else {
      this.checkTrack();
    }
  }

  getTrackingProduct = (product) => {
    const p = this.selligentProducts.find((sku) => sku.ITEMCODE_ID.split('-')[0] == product.metaGroupCode.value);
    product.trackingUrl = p?.tracking_url;
    return product;
  }

  getData = () => {
    const params = {widgetid: this.dataset.widget, lang: this.dataset.lang, loc: this.dataset.country.toLowerCase()};
    if(localStorage.getItem(SelligentCarousel.SID) != undefined) {
      params.sid = localStorage.getItem(SelligentCarousel.SID);
    }
    if(localStorage.getItem(SelligentCarousel.TID) != undefined) {
      params.tid = localStorage.getItem(SelligentCarousel.TID);
    }
    if(this.dataset.widgetContent != undefined) {
      params.widgetcontent = this.dataset.widgetContent;
    }
    var url = `${this.widgetUrl}/api/${this.dataset.customerId}/r?${new URLSearchParams(params).toString()}`;
    if(this.dataset.product != undefined) {
      url = `${this.widgetUrl}/api/${this.dataset.customerId}/rp/${this.dataset.product}/${btoa(location.href)}?${new URLSearchParams(params).toString()}`;
    }
    axios({
      method: 'get',
      url: url
    }).then((response) => {
      this.start(response.data);
    }).catch((error) => {
      console.error(error);
    });
  }

  checkTrack = () => {
    if(localStorage.getItem(SelligentCarousel.SID) == undefined){
      if(this.dataset.customer != undefined) {
        this.fetchTrack();
      } else {
        this.getData();
      }
    } else {
      if(this.dataset.customer == undefined) {
        localStorage.removeItem(SelligentCarousel.SID);
        localStorage.removeItem(SelligentCarousel.TID);
      }
      this.getData();
    }
  }

  fetchTrack = () => {
    axios({
      method: 'post',
      url: SelligentCarousel.trackUrl,
      headers: {
        'Content-Type': 'application/json',
      },
      data: {
        universeId: this.dataset.universe,
        pageTitle: document.title,
        url: window.location.href,
        customIdentifier: this.dataset.customIdentifier || "",
        isIdentificationRequest: true
      }
    })
    .then((response) => {
      localStorage.setItem(SelligentCarousel.SID, response.data.$$profileId);
      localStorage.setItem(SelligentCarousel.TID, response.data.$$thirdPartyId);
      this.getData();
    })
    .catch(function (error) {
      console.error(error);
    });
  }
}
if (!customElements.get('selligent-carousel')) {
  customElements.define('selligent-carousel', SelligentCarousel);
}